import React from 'react';
import Toggle from 'material-ui/Toggle';
import TimePicker from 'material-ui/TimePicker';

export default ({ day, openingTime, closingTime, onChangeOpening, onChangeClosing, active, onToggle }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center',  marginBottom: 16}}>
    <Toggle
      label={day}
      toggled={active}
      onToggle={onToggle}
      labelPosition="right"
      style={{ maxWidth: 200 }}
    />
    <TimePicker
      hintText="Opening Time"
      value={openingTime}
      onChange={onChangeOpening}
      style={{ marginRight: 10 }}
    />
    <TimePicker
      hintText="Closing Time"
      value={closingTime}
      onChange={onChangeClosing}
    />
  </div>
);


// WEBPACK FOOTER //
// ./src/components/BusinessHours.js